import fetch from './fetch.tsx';

export const actions = { fetch };

export type Actions = typeof actions;
